import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach X-Acting-As header when an agent is operating an athlete's workspace.
api.interceptors.request.use((config) => {
  const actingAs = typeof window !== "undefined" ? localStorage.getItem("acting_as_id") : null;
  if (actingAs) {
    config.headers = config.headers || {};
    config.headers["X-Acting-As"] = actingAs;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
